import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/crosslisting-app';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Best Crosslisting Apps of 2021: The Ultimate Guide for Resellers</title>
        <meta
          name='description'
          content='Not all crosslisting apps are made the same. Learn here what each of them offers and see what works for your online selling.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/crosslisting-app' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/crosslisting-app' />
        <meta property='og:title' content='The Best Crosslisting Apps of 2021: The Ultimate Guide for Resellers' />
        <meta
          property='og:description'
          content='Not all crosslisting apps are made the same. Learn here what each of them offers and see what works for your online selling.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-07-23T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-07-23T00:00:00.000Z' />
        <meta property='article:tag' content='Crosslisting' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
